// ============================================================
// 請求書PDFのレスポンス整形
//
// API Gateway (REST API) は、レスポンスをバイナリとして返すか否かを
// binaryMediaTypes の設定と、リクエストの Accept ヘッダーの一致で判定する。
// 設定が無い・一致しない場合、Lambda が base64 で返した本文がそのまま
// テキストとして届き、PDF として開けなくなる。
//
// 本来はインフラ側の設定で解決すべきだが、環境ごとの設定差で画面が
// 壊れるのを避けるため、base64 で届いた場合はここで復元する。
// ============================================================

/** PDF のヘッダー "%PDF-" を base64 にしたときの先頭。判定に使う */
const BASE64_PDF_PREFIX = "JVBERi0";

/** 判定に必要な先頭の長さ（数バイト読めれば十分） */
const PROBE_LENGTH = 16;

/**
 * base64 のテキストとして届いた PDF を、本来のバイナリに戻す（純粋関数）。
 * 既にバイナリであればそのまま返す。
 */
export function decodeBase64Pdf(text: string): Uint8Array {
  const binary = atob(text.replace(/\s/g, ""));
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

/** 先頭が base64 化された PDF かどうか（純粋関数） */
export function looksLikeBase64Pdf(head: string): boolean {
  return head.startsWith(BASE64_PDF_PREFIX);
}

/**
 * 受け取った Blob を、確実に PDF として開ける Blob に整える。
 *
 * base64 のまま届いていた場合は復元する。type を明示するのは、
 * type が付いていない Blob を iframe に渡すとブラウザが表示できないため。
 */
export async function toPdfBlob(received: Blob): Promise<Blob> {
  const head = await received.slice(0, PROBE_LENGTH).text();

  if (looksLikeBase64Pdf(head)) {
    const text = await received.text();
    const bytes = decodeBase64Pdf(text);
    return new Blob([bytes.buffer as ArrayBuffer], {
      type: "application/pdf",
    });
  }

  return new Blob([received], { type: "application/pdf" });
}
